var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgMyTaxi = function SvgMyTaxi(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#my_taxi_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 70,
    height: 70,
    rx: 10,
    fill: "#FCE300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.04 41.481h37.846c3.097 0 5.63 2.538 5.63 5.64v13.487c0 3.102-2.533 5.64-5.63 5.64H31.04c-3.097 0-5.63-2.538-5.63-5.64V47.121c0-3.102 2.533-5.64 5.63-5.64",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.77 58.16c-.644.426-1.304.639-1.98.639-.598 0-1.07-.185-1.416-.556-.346-.37-.518-.91-.518-1.618v-5.528h4.01v-2.031h-4.01v-3.638h-2.453v3.638h-2.524v2.031h2.524v5.694c0 1.417.377 2.492 1.132 3.224.755.733 1.785 1.099 3.09 1.099.927 0 1.894-.3 2.9-.898l-.754-2.055Zm12.56-9.094h-2.454v1.346c-1.07-1.118-2.484-1.677-4.245-1.677-1.573 0-2.933.583-4.08 1.748-1.149 1.165-1.723 2.646-1.723 4.441 0 1.811.57 3.296 1.71 4.453 1.14 1.158 2.505 1.737 4.093 1.737 1.76 0 3.176-.56 4.245-1.678v1.347h2.453V49.066Zm-6.3 9.874c-1.1 0-2.012-.366-2.736-1.098-.723-.733-1.084-1.705-1.084-2.918 0-1.212.361-2.185 1.084-2.917.724-.733 1.636-1.099 2.736-1.099 1.023 0 1.919.374 2.69 1.122.77.748 1.155 1.713 1.155 2.894s-.385 2.146-1.156 2.894c-.77.748-1.666 1.122-2.689 1.122Zm15.553-3.898 4.199-6h-2.948l-3.067 4.441-3.066-4.441h-2.925l4.199 6-4.199 5.74h2.925l3.066-4.228 3.066 4.229h2.949l-4.199-5.74Zm7.041-11.032c-.456 0-.833.15-1.132.449-.299.3-.448.661-.448 1.087 0 .44.15.803.448 1.086.299.284.676.425 1.132.425.456 0 .83-.141 1.12-.425.291-.283.437-.645.437-1.086 0-.426-.15-.788-.448-1.087a1.505 1.505 0 0 0-1.109-.449Zm1.226 16.773V49.066h-2.453v11.717h2.453Z",
    fill: "#FCE300"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.81 25.417c-1.887 0-3.342.717-4.364 2.15a4.002 4.002 0 0 0-1.592-1.583c-.684-.378-1.45-.567-2.3-.567-1.603 0-2.853.551-3.75 1.654v-1.323h-2.452v11.717h2.453v-5.811c0-1.292.279-2.276.837-2.953.558-.677 1.317-1.016 2.276-1.016.77 0 1.403.256 1.899.768.495.512.743 1.193.743 2.043v6.97h2.453v-5.812c0-1.292.283-2.276.849-2.953.566-.677 1.336-1.016 2.311-1.016.77 0 1.404.256 1.899.768.495.512.743 1.193.743 2.043v6.97h2.43V30c0-1.354-.43-2.457-1.286-3.307-.857-.85-1.907-1.276-3.15-1.276Zm17.512.307h-2.736l-3.75 8.457-3.656-8.457h-2.736l5.047 11.458-1.91 4.3h2.736l7.005-15.758Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my_taxi_svg__a",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0865931 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_252366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4_252366",
    result: "shape"
  })))));
};

export default SvgMyTaxi;